export default {
  recordTitle: 'Deposit History',
  detailTitle: 'Transaction Detail',
  empty: 'No deposits match this filter',
  filterType: 'Type',
  filterStatus: 'Status',
  filterTime: 'Time',
  type: {
    all: 'All',
    ewallet: 'E-Wallet',
    crypto: 'Crypto',
    alipay: 'Alipay',
    wechat: 'WeChat',
    bank: 'Bank Card',
    unionpay: 'UnionPay',
  },
  st: {
    all: 'All',
    paid: 'Credited',
    pending: 'Pending',
    confirming: 'Confirming',
    expired: 'Expired',
    cancelled: 'Cancelled',
  },
  detailChannel: 'Channel',
  detailNote: 'Note',
  detailTime: 'Time',
  detailId: 'Order No.',
  detailCurrency: 'Currency',
  detailPayAmount: 'Pay Amount',
  detailBonus: 'Bonus',
  detailRate: 'Locked Rate',
  detailNetwork: 'Network',
  detailAddress: 'Deposit Address',
  detailConfirmations: 'Confirmations',
  detailTxHash: 'Tx Hash',
  detailBankName: 'Bank Name',
  detailAccountName: 'Account Name',
  detailAccountNumber: 'Account Number',
  detailMemo: 'Transfer Memo',
  detailExpireAt: 'Expires At',
  detailTypeKey: 'Type',
  contactSupport: 'Contact Support',
  rechargeRecord: 'Deposit records',
  payment: 'Payment',
  exchangeRate: 'Rate',
  confirmationsText: '{count} confirmations',

  // Balance
  balanceLabel: 'My Balance',
  withdraw: 'Withdraw',

  // Marquee
  marqueeBanner:
    '🔊 First-deposit gift · daily first-deposit rewards · crypto first-deposit bonus · tap to view all promos ›',

  // Type / Channel labels
  typeCrypto: 'Crypto',
  typeEwallet: 'E-Wallet',
  channelThirdParty: ' (3rd Party)',

  // Order Pending - typeChannel prop
  typeChannelCryptoOfficial: 'Crypto · USDT (Official)',
  typeChannelBankTransfer: 'Bank Card · Bank Transfer',
  typeChannelDefault: 'E-Wallet',

  // Order Pending - paymentMethod prop
  paymentMethodOnchain: 'Crypto · On-chain Deposit',
  paymentMethodBankPlatform: 'Bank Card · Bank Transfer (Platform)',

  // Order Success
  walletNameCNY: 'CNY Wallet',
  walletNameUSDT: 'USDT Wallet',
  orderSuccessHint:
    'DepositSucceeded sent (06 Growth Value / 09 Activity Progress Sync) · Activity rewards are separate, please claim in Reward Center',

  // Order Unfinished
  orderUnfinishedTitle: 'Order Incomplete',
  orderUnfinishedSubtitle: 'Channel congested? We recommend a higher success rate channel for you',
  retryCrypto: 'Retry with USDT (Official)',
  retryEwallet: 'Retry with OKPAY',

  // Tips
  tipsTitle: 'Notes',
  tip1: 'Crediting time: fiat channels 1–5 min; USDT per network confirmations (TRC-20 ~1 min) · credited by amount actually received;',
  tip2: 'Pay from your own account with the exact order amount; do not resubmit, change the amount, or pay after timeout;',
  tip3: 'Cross-currency deposit rate is <b>locked at order time</b>; it expires when the order times out / is cancelled, requiring a new quote;',
  tip4: '<b>Channel bonus stacks with deposit event rewards</b>: the bonus is credited with the deposit, claim event rewards in the Promo / Rewards center;',
  tip5: '<b>Third-party channels</b> (e-wallet/Alipay/WeChat/UnionPay) redirect to an external cashier after ordering;<b>In-house channels</b> (bank transfer / official USDT·ETH·BTC on-chain) show payment details on this page;',
  tip6: "If a deposit isn't credited, contact live support with your order No.; channels under maintenance are hidden automatically.",

  // CTA Button
  ctaGetAccount: 'Get Collection Account',
  ctaGenerateOrder: 'Generate Deposit Order',
  ctaRecharge: 'Deposit Now',

  // Embedded wallet deposit (VIPPAY etc. pay_flow=embedded)
  embeddedPhoneLabel: 'Wallet phone number',
  embeddedPhonePlaceholder: 'Enter wallet-registered phone number',
  embeddedPasswordLabel: 'Wallet security password',
  embeddedPasswordPlaceholder: 'Enter wallet security password',
  embeddedPasswordHint: 'The password is used only for this transfer and is never saved or logged',
  embeddedConfirming: 'Transferring…',
  embeddedSuccess: 'Transfer successful, already credited',
  embeddedErrPhone: 'Please enter a valid 11-digit phone number',
  embeddedErrPassword: 'Please enter the wallet security password',
  embeddedErrAmount: 'Invalid amount format',
  embeddedErrRange: 'Amount must be between {min} and {max}',
  embeddedFailWarn:
    'Transfer failed and the result of the previous attempt may be unconfirmed. Do not resubmit, or you may be charged twice. Contact support if in doubt.',
  embeddedRestricted: 'Deposits are restricted for this account. Contact support if in doubt.',

  // Embedded wallet gate popups (VIPPAY etc.)
  gatePhoneTitle: 'Please bind your phone number before using VIPPAY',
  gatePhoneDesc:
    'After binding, you will directly use this phone number to log in to VIPPAY without entering an account or password.',
  gatePhoneCta: 'Go bind phone number',
  gateCancel: 'Cancel',
  gateFundTitle: 'Set a fund password first',
  gateFundDesc:
    'To use quick login with your bound phone number, set a fund password in the Security Center first; you can also log in with another VIPPAY account directly.',
  gateFundInfo: 'Set up once; no need to re-enter the fund password when confirming payment.',
  gateFundCta: 'Go set fund password',
  gateFundManual: '+ Manually enter another account',
  gateFundManualDesc:
    "Other accounts do not need this site's fund password; you still need to enter that account's password each time you log in.",

  // Account picker (after phone bound / fund password already set)
  gateAccountTitle: 'Choose a VIPPAY account to log in',
  gateAccountDesc:
    'Use the account bound to this site, or choose another account you have used before',
  gateAccountBound: 'Phone bound to this site',
  gateAccountFree: 'No password required',
  gateAccountManualDesc:
    'Other accounts require a password each time; only the phone number is remembered, passwords are never saved.',
  gateAccountCta: 'Confirm and continue',
  // Log in with another VIPPAY account
  gateManualBack: 'Back to account picker',
  gateManualTitle: 'Log in to another VIPPAY account',
  gateManualDesc:
    "Enter that account's phone number and password; this deposit will be paid from that account.",
  gateManualPhoneLabel: 'VIPPAY phone number',
  gateManualPhonePh: 'Enter 11-digit phone number',
  gateManualPwdLabel: 'Login password',
  gateManualPwdPh: "Enter that account's password",
  gateManualHint:
    'Prototype login only; the third-party password is not verified and is never saved.',
  gateManualCta: 'Log in and continue',

  // Recently used other accounts
  gateRecentTitle: 'Recently used other accounts',
  gateRecentLogin: 'Enter password to log in',

  // VIPPAY secure payment page (other account)
  gatePayTitle: 'VIPPAY',
  gatePayHeading: 'VIPPAY Secure Payment',
  gatePaySub: 'Logged in with another VIPPAY account',
  gatePaySubSystem: 'Quick login with the phone bound to this site',
  gatePayOtherAccount: 'Other account',
  gatePaySystemAccount: 'Site account',
  gatePayLockedTag: 'Locked for this order',
  gatePayAmountLabel: 'Payment amount',
  gatePayOrderLabel: 'Merchant order',
  gatePayArriveLabel: 'Estimated arrival',
  gatePayLockHint:
    'The payment account for this order is locked. To switch, go back, cancel the order and choose again.',
  gatePayCta: 'Confirm payment',
  gatePayDoing: 'Confirming…',
  gatePayFooter:
    'Payment information is encrypted by VIPPAY; the payment result is subject to the merchant arrival notice.',

  // Amount text (with interpolation)
  arrivedApprox: 'Arrived approx. {amount}',
  arrivedWithBonus: 'Arrived approx. {amount}, incl. bonus {bonus}',

  // Rate text
  rateCnyToUsdt: '1 CNY ≈ {rate} USDT',
  rateCryptoToUsdt: '1 {currency} ≈ {rate} USDT',
  rateCryptoToCny: '1 {currency} ≈ ¥{rate}',

  // Mock bank data
  bankName: 'China Merchants Bank',
  accountName: 'Wang *cheng',
  confirmCount: '{count} confirmations',
  cryptoNote:
    'Credited by actual received amount · Do not send other tokens to this address · {count} confirmations ≈ 1 min (docs 03 ③)',

  // RechargeForm - Section titles
  rechargeType: 'Deposit Method',
  rechargeChannel: 'Deposit Channel',
  channelWindow: 'Available daily {window}',
  rechargeAmount: 'Deposit Amount',

  // RechargeForm - Labels & placeholders
  depositLabel: 'Amount',
  enterAmountPlaceholder: 'Enter deposit amount',
  selectChannelFirst: 'Select a deposit channel',

  // RechargeForm - Range text (with interpolation)
  rangeFmtCrypto: 'Deposit range {min} {currency} – {max} {currency}({name})',
  rangeFmtFiat: 'Deposit range ¥{min} – ¥{max}({name})',

  // RechargeForm - Error messages
  minRechargeError: 'Min. deposit ¥{min}',
  maxRechargeError: 'Max. deposit ¥{max}',

  // RechargeForm - Get amount label
  getAmountWithBonus: '💰 You get (incl. channel bonus {bonus})',
  getAmountNoBonus: '💰 You get (credited to current wallet)',

  // RechargeForm - Rate text
  rateReference: 'Ref. rate {from} ≈ {to} · locked at order time, void when the order closes',

  // Recharge type labels (keyed by type key)
  typeLabel_ewallet_name: 'E-Wallet',
  typeLabel_ewallet_subtitle: 'Bonus every time',
  typeLabel_ewallet_tag: 'Popular',
  typeLabel_crypto_name: 'Crypto',
  typeLabel_crypto_subtitle: 'On-chain deposit',
  typeLabel_crypto_tag: 'Secure',
  typeLabel_alipay_name: 'Alipay',
  typeLabel_alipay_subtitle: 'One-tap pay',
  typeLabel_alipay_tag: 'Instant',
  typeLabel_wechat_name: 'WeChat',
  typeLabel_wechat_subtitle: 'Fast & easy',
  typeLabel_wechat_tag: 'Stable',
  typeLabel_bank_name: 'Bank Card',
  typeLabel_bank_subtitle: 'Large transfer',
  typeLabel_bank_tag: 'Stable',
  typeLabel_unionpay_name: 'UnionPay',
  typeLabel_unionpay_subtitle: 'UnionPay QR',
  typeLabel_unionpay_tag: 'Stable',

  // Channel names (keyed by channel id, Chinese-named channels only)
  channelName_4: 'Wave Coin',
  channelName_5: 'NO Wallet',
  channelName_7: 'Win Coin',
  channelName_9: 'K Bean',
  channelName_11: '808 Wallet',
  channelName_12: '365 Wallet',
  channelName_13: 'HD Wallet',
  channelName_14: 'C Coin Wallet',
  channelName_15: 'SPAY Wallet',
  channelName_16: 'TGPAY Wallet',
  channelName_101: 'USDT (Official)',
  channelName_102: 'USDT Scan',
  channelName_103: 'USDT Transfer',
  channelName_104: 'USDT Large',
  channelName_105: 'USDT Small',
  channelName_106: 'ETH Scan',
  channelName_107: 'ETH Large',
  channelName_108: 'BTC Scan',
  channelName_109: 'BTC Large',
  channelName_201: 'Alipay Small 1',
  channelName_202: 'Alipay Small 2',
  channelName_203: 'Alipay Scan',
  channelName_204: 'Alipay Large',
  channelName_205: 'Alipay Gold',
  channelName_301: 'WeChat Small 1',
  channelName_302: 'WeChat Small 2',
  channelName_303: 'WeChat Scan',
  channelName_304: 'WeChat Large',
  channelName_401: 'Bank Transfer',
  channelName_501: 'UnionPay Scan',
  channelName_502: 'UnionPay Transfer',

  // Channel iconText (keyed by iconKey, shared keys for same icon)
  channelIcon_1: 'VIP',
  channelIcon_2: 'GO',
  channelIcon_3: 'OK',
  channelIcon_4: 'W',
  channelIcon_5: 'NO',
  channelIcon_6: 'TO',
  channelIcon_7: 'W',
  channelIcon_8: 'U',
  channelIcon_9: 'KB',
  channelIcon_10: 'JJ',
  channelIcon_808: '808',
  channelIcon_365: '365',
  channelIcon_HD: 'HD',
  channelIcon_alipay: 'A',
  channelIcon_wechat: 'W',
  channelIcon_bank: 'B',
  channelIcon_unionpay: 'U',

  // OrderPending - Titles & labels
  orderPendingTitle: 'Order pending payment',
  orderIdLabel: 'Order No.',
  amountLabel: 'Payment Amount',
  typeChannelLabel: 'Method · Channel',
  paymentMethodLabel: 'Payment Method',
  lockedRateLabel: 'Rate Locked',
  remainingTimeLabel: 'Time left to pay',

  // OrderPending - Bank info labels
  bankNameLabel: 'Beneficiary Bank',
  accountNameLabel: 'Account Name',
  cardNumberLabel: 'Card Number',
  transferAmountLabel: 'Transfer Amount (incl. tail)',
  transferRemarkLabel: 'Transfer Remark (Required)',

  // OrderPending - Crypto info labels
  networkLabel: 'Network',
  depositAddressLabel: 'Deposit Address',
  confirmCountLabel: 'Confirmations',

  // OrderPending - Buttons & actions
  copyBtn: 'Copy',
  waitingConfirming: 'Waiting for confirmation',
  doneTransfer: 'Transfer completed',
  donePayment: 'Payment completed',
  cancelOrder: 'Cancel Order',
  reopenPayment: 'Reopen payment page',
  reopenVippay: 'Open VIPPAY',
  orderCancelled: 'Order cancelled',
  orderPaid: 'Order credited',
  orderExpired: 'Order expired',
  orderTransferredSuccess: 'Transfer confirmed, awaiting credit',
  orderTransferredFailed: 'Operation failed, please retry',
  orderRechargeTimeout: 'Payment not confirmed. Please check if the transfer was successful.',
  orderCancelledBySystem: 'Order cancelled',
  orderCannotBeCancelled: 'The order payment has been confirmed and cannot be closed',

  // OrderSuccess - Labels & text
  orderSuccessTitle: 'Deposit Successful',
  orderCredited: 'Credited',
  creditedAmountLabel: 'Credited Amount',
  creditedWalletLabel: 'Credited Wallet',
  doneBtn: 'Done',

  // OrderPending - Notes / hints
  bankNote:
    'Please transfer the exact amount (incl. tail) using your own bank card and fill in remark 8866 (auto-verification, docs 03 ②)',
  thirdPartyNote:
    'Third-party cashier opened in a new window. Return here after payment. Not showing?',

  // WithdrawForm - Titles & labels
  withdrawRecords: 'Withdrawal records',
  withdrawAmountLabel: 'Withdrawal amount',
  withdrawablePrefix: 'Withdrawable',
  withdrawTo: 'Withdraw to',
  selectWithdrawAccount: 'Select a withdrawal account',
  accountTypeHint: 'E-wallet / Crypto / Bank card / Alipay',
  changeAccount: 'Change',
  allBtn: 'All',

  // WithdrawForm - Fee card
  feeLabel: 'Fee',
  feeLabelRate: 'Fee ({rate}%)',
  feeFree: 'Free',
  estimatedArrival: 'Estimated arrival',
  refRate: 'Ref. rate',
  choosePayoutHint: 'Choose a payout method to calculate fees and arrival',

  // WithdrawForm - Hints
  withdrawHintTop: 'As fast as 5-10 min · min per transaction',
  withdrawMinUsdt: '20 USDT',
  withdrawMinCny: '¥100',
  withdrawHintBottom:
    'Double-check the payee details; transfers to others accounts cannot be recovered',

  // WithdrawForm - Button & errors
  confirmWithdraw: 'Confirm Withdrawal',
  selectAccountFirst: 'Select a withdrawal account',
  errEnterWithdrawAmount: 'Enter withdrawal amount',
  errWithdrawBelowMin: 'Minimum withdrawal is {amount}',
  errSelectWithdrawAccount: 'Select a withdrawal account',
  errNeedKyc: 'This account requires KYC verification before withdrawal',
  // Inline hint / button state / over-balance toast
  withdrawBelowMinGap: '{amount} more to reach the minimum',
  withdrawMinOnly: 'Minimum {amount} per transaction',
  withdrawOverBalance: 'Exceeds withdrawable balance',
  errWithdrawOverBalance: 'Insufficient withdrawable balance, up to {amount} available',

  // WithdrawForm - Account display prefixes
  accountPrefixEwallet: 'E-wallet',
  accountPrefixCrypto: 'Crypto',
  accountPrefixBank: 'Bank card',
  accountPrefixAlipay: 'Alipay',

  // WithdrawResult - Titles & text
  withdrawResultTitle: 'Withdrawal Result',
  withdrawSubmitted: 'Withdrawal request submitted',
  withdrawArrivingSoon: '⚡ Arriving in 5-10 min',
  accountCreditedLabel: 'Payout account',
  statusLabel: 'Status',
  statusProcessing: 'Processing',
  estimatedArrivalTime: 'Est. arrival',
  arrivalInTime: '· within 5-10 min',
  flowIdLabel: 'Ref. No.',
  viewWithdrawRecords: 'View Withdraw Records',

  // KYC - Title & guide
  kycTitle: 'Identity Verification',
  kycGuideTitle: '🛡 Why is verification required?',
  kycGuide1: '· Per regulatory & AML requirements, we must verify your real identity',
  kycGuide2:
    '· Protects your account & funds:<b>the payout account must match your verified identity</b>',
  kycGuide3: '· Data is encrypted and used only for compliance checks, nothing else',

  // KYC - Labels & placeholders
  kycDocumentType: 'Document Type',
  kycIdCard: 'National ID',
  kycPassport: 'Passport',
  kycRealName: 'Real Name',
  kycRealNamePlaceholder: 'Must match document name (2–20 Chinese characters)',
  kycIdNumber: 'ID Card No.',
  kycPassportNumber: 'Passport No.',
  kycIdNumberPlaceholder: '18-digit ID (last digit can be X)',
  kycPassportPlaceholder: '8-9 digit passport number',
  kycExpiryDate: 'Document Validity',
  kycExpiryPlaceholder: '2030-12-31',
  kycLongTerm: 'No expiry',
  kycDocumentPhotos: 'Document Photos',

  // KYC - Photo tiles
  kycIdPortrait: 'ID · Portrait Side',
  kycIdEmblem: 'ID · Emblem Side',
  kycPassportData: 'Passport · Data Page',
  kycSelfie: 'Selfie with Document',
  kycUploadHint: 'Take a photo or upload',
  kycReupload: 'Re-upload',
  kycUploading: 'Uploading…',

  // KYC - Requirements & agreement
  kycPhotoRequirement:
    'Requirements: Full document edges · legible text · no glare/obstruction · ≤5MB each; the selfie must show your face and document clearly together',
  kycAgreeText:
    'I have read and agree to the <a href="#" class="link-inline" data-nav="privacy">Privacy Policy</a>, authorizing use of the above info for identity verification',

  // KYC - Submit button
  kycSubmit: 'Submit',
  kycSubmitting: 'Submitting…',
  kycDemoTag: 'Prototype',
  kycDemoBar: 'account flagged with kycRequired',
  kycDemoFill: 'Fill demo data',
  kycDemoFilled: 'Demo verification data filled in',

  // KYC - Processing state
  kycProcessingTitle: 'Verification in Progress',
  kycProcessingDesc: 'Expected to complete in 1–3 minutes (OCR + manual review)',
  kycProcessingDesc2:
    'You will be notified automatically upon approval, and the withdrawal will continue',
  kycProcessingNotify: 'You will be notified automatically upon approval',
  kycSubmitted: 'Submitted, pending review (OCR + manual)',

  // KYC - Withdraw page status card
  kycCardTitle: 'Account Security Verification',
  kycCardDesc: 'Real-name verification is required before withdrawal',
  kycGoVerify: 'Verify Now',
  kycVerifiedTag: 'Verified',
  kycPendingTag: 'Pending',
  kycRejectedTag: 'Rejected',

  // KYC - Rejected page (/kyc/details rejected)
  kycRejectedTitle: 'Verification Failed',
  kycRejectedDesc: 'Please fix the issue and resubmit. Your previous info is preserved.',
  kycRejectedReason: 'Rejection reason: ',
  kycResubmit: 'Resubmit',
  kycCardSubApproved: 'Real-name verification completed',
  kycCardSubPending: 'Under review, 1–3 business days',
  kycCardSubRejected: 'Not verified, please correct and resubmit',

  // KYC - Verified detail page
  kycDetailTitle: 'Real-name Verification Completed',
  kycDetailDesc1: 'Your real-name info is encrypted and locked',
  kycDetailDesc2: 'Withdrawal account must match real-name; contact support to change',
  kycDetailDocType: 'Document Type',
  kycDetailRealName: 'Real Name',
  kycDetailIdNumber: 'Document Number',
  kycDetailExpiry: 'Validity',

  // KYC - Processing card labels
  kycMaskedNameLabel: 'Real Name',
  kycMaskedNumberLabel: 'Document No.',
  kycMaskedIdTypeLabel: 'Document Type',
  kycMaskedExpiryLabel: 'Validity',

  // KYC - Error messages
  kycErrName: 'Name must be 2–20 Chinese characters (can include ·)',
  kycErrIdNumber: 'ID card number is incorrect, please check and re-enter',
  kycErrPassportNumber: 'Passport number should be 8–9 alphanumeric characters',
  kycErrExpiryInvalid: 'Please enter a valid expiry date (e.g. 2030-12-31) or check No expiry',
  kycErrExpiryExpired: 'Document has expired, cannot be verified',
  kycErrUploadAllId: 'Please upload all document photos (portrait, emblem, and selfie)',
  kycErrUploadAllPassport: 'Please upload all document photos (data page and selfie)',
  kycErrAgree: 'Please read and agree to the Privacy Policy',
  kycErrFileType: 'Only JPG, PNG, WebP photos are supported',
  kycErrFileSize: 'Photo must be 5MB or smaller, please reselect',
  kycErrUploading: 'Photo upload failed, please reselect',
  kycErrPhotoPending: 'Photos are still uploading, please wait before submitting',
  kycErrRejected: 'Your previous submission was rejected. Please correct it and resubmit.',
}
